import React, { useEffect } from "react";
import { notification, Button } from "antd";
import axiosInstance from "../../service/AxiosInstance";
import { APP_PREFIX_PATH } from "../../Config/AppConfig";
import { useNavigate } from "react-router-dom"; 

export const PortfolioNotification = () => {
  const navigate = useNavigate();
  useEffect(() => {
    fetchNotification();
  }, []);
  const deleteNotification = async (sharingIds) => {
    try {
      await axiosInstance.delete("/sharenotification", {
        data: { sharing_ids: sharingIds },
      });
      notification.destroy();
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  const fetchNotification = async () => {
    try {
      const response = await axiosInstance.get("/sharenotification");

      if (response.data) {
        showNotification(response.data);
      }
    } catch (error) {
      console.error("Error fetching notification:", error);
    }
  };
  const showNotification = (data) => {
    const messages = data
      .map((notificationData) => notificationData.message)
      .join("\n");

    notification.info({
      message: "Portfolios Shared",
      description: (
        <div>
          {data.map((notificationData, index) => (
            <div key={index} style={{ marginBottom: "8px" }}>
              {notificationData.message}
            </div>
          ))}
          <div>
            <Button
              type="link"
              size="small"
              onClick={() => {
                const sharingIds = data.map((item) => item.id);
                handleViewPortfolio(sharingIds);
              }}
              className="custom-button"
            >
              View
            </Button>
          </div>
        </div>
      ),
      placement: "topRight",
      duration: 0,
      closeIcon: false,
      className: "notification-container",
      btn: (
        <span
          onClick={async () => {
            const sharingIds = data.map((item) => item.id);
            await deleteNotification(sharingIds);
          }}
          className="close-button"
        >
          X
        </span>
      ),
    });

    const handleClick = async (event) => {
      const notificationElement = document.querySelector(
        ".notification-container"
      );
      if (notificationElement && !notificationElement.contains(event.target)) {
        const sharingIds = data.map((item) => item.id);
        await deleteNotification(sharingIds);
        document.removeEventListener("click", handleClick);
      }
    };

    document.addEventListener("click", handleClick);
  };

  const handleViewPortfolio = async (sharingIds) => {
    // Call deleteNotification before redirecting
    await deleteNotification(sharingIds);

    // Redirect to the portfolio page
    navigate(`/${APP_PREFIX_PATH}/Portfolio/PortfolioDirectory`);
  };

  return <></>;
};
